import { render, staticRenderFns } from "./crops_admin.vue?vue&type=template&id=9b4741e2&"
import script from "./crops_admin.vue?vue&type=script&lang=js&"
export * from "./crops_admin.vue?vue&type=script&lang=js&"
import style0 from "./crops_admin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports